import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState
} from "react";
import { useLocation } from "react-router-dom";

/* =========================
   Countries for phone codes
   ========================= */
const COUNTRIES = [
  { code: "+20",  name: "Egypt",                flag: "🇪🇬" },
  { code: "+966", name: "Saudi Arabia",         flag: "🇸🇦" },
  { code: "+971", name: "United Arab Emirates", flag: "🇦🇪" },
  { code: "+1",   name: "United States",        flag: "🇺🇸" },
  { code: "+44",  name: "United Kingdom",       flag: "🇬🇧" },
  { code: "+49",  name: "Germany",              flag: "🇩🇪" },
  { code: "+39",  name: "Italy",                flag: "🇮🇹" },
  { code: "+34",  name: "Spain",                flag: "🇪🇸" },
  { code: "+33",  name: "France",               flag: "🇫🇷" },
  { code: "+41",  name: "Switzerland",          flag: "🇨🇭" },
  { code: "+90",  name: "Turkey",               flag: "🇹🇷" },
  { code: "+974", name: "Qatar",                flag: "🇶🇦" },
  { code: "+965", name: "Kuwait",               flag: "🇰🇼" },
  { code: "+973", name: "Bahrain",              flag: "🇧🇭" },
  { code: "+968", name: "Oman",                 flag: "🇴🇲" },
  { code: "+962", name: "Jordan",               flag: "🇯🇴" },
  { code: "+961", name: "Lebanon",              flag: "🇱🇧" },
  { code: "+212", name: "Morocco",              flag: "🇲🇦" },
  { code: "+213", name: "Algeria",              flag: "🇩🇿" },
  { code: "+216", name: "Tunisia",              flag: "🇹🇳" },
  { code: "+249", name: "Sudan",                flag: "🇸🇩" },
  { code: "+254", name: "Kenya",                flag: "🇰🇪" },
  { code: "+27",  name: "South Africa",         flag: "🇿🇦" },
  { code: "+234", name: "Nigeria",              flag: "🇳🇬" },
  { code: "+91",  name: "India",                flag: "🇮🇳" },
  { code: "+62",  name: "Indonesia",            flag: "🇮🇩" },
  { code: "+81",  name: "Japan",                flag: "🇯🇵" },
  { code: "+82",  name: "South Korea",          flag: "🇰🇷" },
  { code: "+86",  name: "China",                flag: "🇨🇳" },
  { code: "+852", name: "Hong Kong",            flag: "🇭🇰" },
  { code: "+853", name: "Macau",                flag: "🇲🇴" },
  { code: "+61",  name: "Australia",            flag: "🇦🇺" },
  { code: "+64",  name: "New Zealand",          flag: "🇳🇿" },
  { code: "+52",  name: "Mexico",               flag: "🇲🇽" },
  { code: "+55",  name: "Brazil",               flag: "🇧🇷" },
  { code: "+54",  name: "Argentina",            flag: "🇦🇷" },
  { code: "+7",   name: "Russia",               flag: "🇷🇺" },
  { code: "+380", name: "Ukraine",              flag: "🇺🇦" },
  { code: "+46",  name: "Sweden",               flag: "🇸🇪" },
  { code: "+47",  name: "Norway",               flag: "🇳🇴" },
  { code: "+45",  name: "Denmark",              flag: "🇩🇰" },
  { code: "+31",  name: "Netherlands",          flag: "🇳🇱" },
  { code: "+32",  name: "Belgium",              flag: "🇧🇪" },
  { code: "+30",  name: "Greece",               flag: "🇬🇷" },
  { code: "+48",  name: "Poland",               flag: "🇵🇱" },
  { code: "+351", name: "Portugal",             flag: "🇵🇹" },
  { code: "+420", name: "Czech Republic",       flag: "🇨🇿" },
  { code: "+43",  name: "Austria",              flag: "🇦🇹" },
  { code: "+353", name: "Ireland",              flag: "🇮🇪" },
  { code: "+63",  name: "Philippines",          flag: "🇵🇭" },
  { code: "+84",  name: "Vietnam",              flag: "🇻🇳" },
  { code: "+66",  name: "Thailand",             flag: "🇹🇭" },
  { code: "+65",  name: "Singapore",            flag: "🇸🇬" },
  { code: "+60",  name: "Malaysia",             flag: "🇲🇾" },
];

/* =========================
   Brand config + detection
   ========================= */
const BRANDS = {
  earthscan: {
    key: "earthscan",
    name: "EarthScan",
    siteUrl: "https://earthscan.sobekglobal.com",
    logo: "/Asset 2.png"
  },
  sobek: {
    key: "sobek",
    name: "SOBEK",
    siteUrl: "https://sobekglobal.com",
    logo: "/Asset 2.png"
  },
  drone: {
    key: "drone",
    name: "Drone Pilot",
    siteUrl: "https://dronepilott.com",
    logo: "/Asset 2.png"
  }
};

// helper: get query ?brand / etc.
function getQueryParam(name) {
  const sp = new URLSearchParams(window.location.search);
  return sp.get(name) || "";
}
function getService() {
  return window.location.origin + "/app/profile";
}
function detectBrandKey() {
  const q = (getQueryParam("brand") || "").toLowerCase();
  if (["sobek", "drone", "earthscan"].includes(q)) return q;

  const cand = [];
  cand.push(window.location.hostname.toLowerCase());
  if (document.referrer) {
    cand.push(document.referrer.toLowerCase());
    try {
      const u = new URL(document.referrer);
      cand.push(u.hostname.toLowerCase());
    } catch (e) { /* noop */ }
  }
  const match = (hay) => {
    if (/drone|dronepilot|dronepilott/.test(hay)) return "drone";
    if (/sobek/.test(hay)) return "sobek";
    if (/earthscan|earth-scan|earth\s*scan/.test(hay)) return "earthscan";
    return null;
  };
  for (const h of cand) {
    const m = match(h);
    if (m) return m;
  }
  return "earthscan";
}

/* =========================
   Deep helpers
   ========================= */
function isObject(x) { return x && typeof x === "object"; }
function deepFindFirst(obj, names) {
  if (!isObject(obj)) return "";
  const queue = [obj];
  const targets = names.map(s => s.toLowerCase());
  const seen = new Set();
  while (queue.length) {
    const cur = queue.shift();
    if (!isObject(cur) || seen.has(cur)) continue;
    seen.add(cur);
    for (const k of Object.keys(cur)) {
      const v = cur[k];
      if (targets.includes(String(k).toLowerCase())) {
        const sv = String(v);
        if (
          v !== undefined &&
          v !== null &&
          (typeof v === "string" ? sv.trim() !== "" : true)
        ) {
          return v;
        }
      }
      if (isObject(v)) queue.push(v);
      if (Array.isArray(v)) {
        for (const it of v) if (isObject(it)) queue.push(it);
      }
    }
    if (Array.isArray(cur)) {
      for (const it of cur) {
        if (isObject(it)) queue.push(it);
      }
    }
  }
  return "";
}
function normalizeAny(userish = {}) {
  const id        = deepFindFirst(userish, ["id","user_id","uid"]);
  const username  = deepFindFirst(userish, ["username","user_name","login","uname"]);
  const name      = deepFindFirst(userish, ["name","fullname","full_name","displayName","display_name"]);
  const email     = deepFindFirst(userish, ["email","mail","email_address","emailAddress"]);
  const whatsapp  = deepFindFirst(userish, ["whatsapp","phone","mobile","msisdn"]);
  const avatar    = deepFindFirst(userish, ["avatar","photo","picture","avatar_url","image","profile_image"]);
  const createdAt = deepFindFirst(userish, ["created_at","createdAt","member_since","joined_at","created"]);

  return {
    id: id || null,
    username: username || "",
    name: name || "",
    email: email || "",
    whatsapp: whatsapp || "",
    avatar: avatar || "",
    created_at: createdAt || ""
  };
}
function mergeProfile(a, b) {
  const out = { ...a };
  for (const k of Object.keys(b)) {
    if (!out[k]) out[k] = b[k];
  }
  return out;
}

/* =========================
   brand → sections mapping
   ========================= */
function getSectionsForBrand(brandKey) {
  if (brandKey === "sobek") {
    return [
      { key: "personal", label: "Account" },
      { key: "orders", label: "Orders" },
      { key: "history", label: "History" },
    ];
  }
  if (brandKey === "drone") {
    return [
      { key: "personal", label: "Account" },
      { key: "courses", label: "My Courses" },
      { key: "certs", label: "Certificates" },
      { key: "billing", label: "Payment History" },
    ];
  }
  // default earthscan
  return [
    { key: "personal",      label: "Account" },
    { key: "Favorite",     label: "Favorite" },
    { key: "subscription",  label: "Orders" },
    { key: "billing",       label: "Payment & Billing" },
  ];
}

/* =========================
   Profile Component
   ========================= */
export default function Profile(props) {
  const location = useLocation();
  const ticket = location.state?.ticket || null;
  if (!ticket) {
    console.warn("Profile component loaded without ticket in state.");
    //redirect to login or show an error
    window.location.href = "https://cas.user-hub.com/login.php?service=" + encodeURIComponent(getService());
  }
  const brandKey = useMemo(() => detectBrandKey(), []);
  const brand = BRANDS[brandKey] || BRANDS.earthscan;

  // sections list depends on brand
  const sectionsList = useMemo(() => getSectionsForBrand(brandKey), [brandKey]);

  // selectedSection: default أول سكشن
  const [selectedSection, setSelectedSection] = useState(
    sectionsList[0]?.key || "personal"
  );

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState("");

  // edit toggle
  const [canEdit, setCanEdit] = useState(false);

  // Profile state من السيرفر
  const [profile, setProfile] = useState({
    id: null,
    username: "",
    name: "",
    email: "",
    whatsapp: "",
    avatar: "",
    created_at: ""
  });

  // DOB (UI only)
  const [dobDay, setDobDay] = useState("");
  const [dobMonth, setDobMonth] = useState("");
  const [dobYear, setDobYear] = useState("");

  // History local only
  const [historyItems, setHistoryItems] = useState([]);

  // Split phone UI states
  const [waCountryCode, setWaCountryCode] = useState("+966");
  const [waLocal, setWaLocal] = useState("");

  // Password change UI state
  const [showPwdChange, setShowPwdChange] = useState(false);
  const [oldPwd, setOldPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);

  // layout refs
  const gridRef = useRef(null);
  const leftColRef = useRef(null);
  const avatarCardRef = useRef(null);
  // NEW: reference to keep original values (no deletion elsewhere)
  const originalRef = useRef({ name: "", whatsapp: "" });

  const DEFAULT_RIGHT_OFFSET = 132;
  const [rightOffset, setRightOffset] = useState(DEFAULT_RIGHT_OFFSET);

  useLayoutEffect(() => {
    function measure() {
      if (!gridRef.current || !leftColRef.current || !avatarCardRef.current) {
        setRightOffset(DEFAULT_RIGHT_OFFSET);
        return;
      }
      const avatarH = avatarCardRef.current.offsetHeight || 0;

      // ✅ بداية كارت اليمين قرب منتصف كارت الصورة
      const offset = Math.round(Math.max(24, avatarH / 2 - 10));

      setRightOffset(offset);
    }

    measure();
    const t1 = requestAnimationFrame(measure);
    const t2 = setTimeout(measure, 60);

    let ro;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(measure);
      ro.observe(document.body);
      if (leftColRef.current) ro.observe(leftColRef.current);
      if (gridRef.current) ro.observe(gridRef.current);
      if (avatarCardRef.current) ro.observe(avatarCardRef.current);
    }

    window.addEventListener("resize", measure);
    window.addEventListener("load", measure);

    return () => {
      cancelAnimationFrame(t1);
      clearTimeout(t2);
      if (ro) ro.disconnect();
      window.removeEventListener("resize", measure);
      window.removeEventListener("load", measure);
    };
  }, []);

  // 👇 ثابت الخلفية وإزالة المارجن الافتراضي
  useEffect(() => {
    const htmlEl = document.documentElement;
    const prevHtmlBg = htmlEl.style.backgroundColor;
    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyMargin = document.body.style.margin;

    htmlEl.style.backgroundColor = "#111";
    document.body.style.backgroundColor = "#111";
    document.body.style.margin = "0";

    return () => {
      htmlEl.style.backgroundColor = prevHtmlBg;
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.margin = prevBodyMargin;
    };
  }, []);

  // helper: init waCountryCode/waLocal from full phone
  function initPhoneSplit(fullPhone) {
    if (!fullPhone || typeof fullPhone !== "string") {
      setWaCountryCode("+966");
      setWaLocal("");
      return;
    }

    let bestMatch = null;
    for (const c of COUNTRIES) {
      if (fullPhone.startsWith(c.code)) {
        if (!bestMatch || c.code.length > bestMatch.code.length) {
          bestMatch = c;
        }
      }
    }

    if (bestMatch) {
      setWaCountryCode(bestMatch.code);
      setWaLocal(fullPhone.substring(bestMatch.code.length));
    } else {
      setWaCountryCode("+966");
      setWaLocal(fullPhone.replace(/^\+/, ""));
    }
  }

  // Fetch profile & ticket exchange
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const sp = new URLSearchParams(window.location.search);
        const ticket = sp.get("ticket");

        if (ticket) {
          try {
            const service = getService();

            // 1) exchange ticket -> sets session cookie on user-hub.com
            await fetch(
              `https://user-hub.com/cas/login.php?service=${encodeURIComponent(
                service
              )}&ticket=${encodeURIComponent(ticket)}`,
              { method: "GET", credentials: "include" }
            );

            // 2) validate (info only)
            let vdata = {};
            try {
              const validateUrl =
                `https://cas.user-hub.com/validate.php` +
                `?service=${encodeURIComponent(service)}` +
                `&ticket=${encodeURIComponent(ticket)}`;
              const vres = await fetch(validateUrl, {
                method: "GET",
                credentials: "omit",
                headers: { Accept: "application/json" }
              });
              const vraw = await vres.text();
              vdata = JSON.parse(vraw);
            } catch (e) {
              // ignore
            }

            // 3) read DB profile (cookie)
            let me = {};
            try {
              const meRes = await fetch("https://user-hub.com/me.php", {
                method: "GET",
                credentials: "include",
                headers: { Accept: "application/json" }
              });
              const meRaw = await meRes.text();
              me = JSON.parse(meRaw);
            } catch (e) {
              // ignore
            }

            const normValidate = normalizeAny(
              (vdata && (vdata.user || vdata.data?.user)) || vdata || {}
            );
            const normMe = normalizeAny(
              (me && (me.user || me.data?.user)) || me || {}
            );
            const merged = mergeProfile(normMe, normValidate);

            setProfile(merged);
            initPhoneSplit(merged.whatsapp);
            // NEW: keep originals after load (ticket flow)
            originalRef.current = { name: merged.name || "", whatsapp: merged.whatsapp || "" };

            // clean ?ticket from URL
            const clean = new URL(window.location.href);
            clean.searchParams.delete("ticket");
            window.history.replaceState({}, "", clean.toString());

            setLoading(false);
            return;
          } catch (err) {
            console.error("ticket-flow error:", err);
            setToast("⚠️ Failed to load profile.");
          }
        }

        // normal flow (already logged in)
        const res = await fetch("https://user-hub.com/me.php", {
          method: "GET",
          credentials: "include",
          headers: { Accept: "application/json" }
        });

        if (res.status === 401 || res.status === 403) {
          const to = new URL("https://cas.user-hub.com/login.php");
          to.searchParams.set("service", getService());
          to.searchParams.set("brand", brand.key);
          window.location.href = to.toString();
          return;
        }

        const raw = await res.text();
        let data = {};
        try {
          data = JSON.parse(raw);
        } catch (e) {
          data = {};
        }

        const normalized = normalizeAny(
          data.user || data.data?.user || data || {}
        );
        setProfile(normalized);
        initPhoneSplit(normalized.whatsapp);
        // NEW: keep originals after load (normal flow)
        originalRef.current = { name: normalized.name || "", whatsapp: normalized.whatsapp || "" };
      } catch (e) {
        console.error(e);
        setToast("⚠️ Failed to load profile.");
      } finally {
        setLoading(false);
        setTimeout(() => setToast(""), 3000);
      }
    })();
  }, [brand.key]);

  // load history
  useEffect(() => {
    try {
      const searched = JSON.parse(
        localStorage.getItem("es_searchHistory") || "[]"
      );
      const downloaded = JSON.parse(
        localStorage.getItem("es_downloadedAreas") || "[]"
      );
      const map = new Map();
      for (const it of [...searched, ...downloaded]) {
        const key =
          (it && (it.name || it.query)) || JSON.stringify(it);
        if (!map.has(key)) map.set(key, it);
      }
      setHistoryItems(
        Array.from(map.values())
          .slice(-50)
          .reverse()
      );
    } catch (e) {
      setHistoryItems([]);
    }
  }, []);

  // ====== Edit handlers ======
  function toggleEdit() {
    setCanEdit((v) => !v);
  }

  function handleNameChange(newName) {
    setProfile({ ...profile, name: newName });
  }

  function handleWaCountryChange(newCode) {
    setWaCountryCode(newCode);
    const newFull = newCode + waLocal;
    setProfile({ ...profile, whatsapp: newFull });
  }

  function handleWaLocalChange(newLocal) {
    setWaLocal(newLocal);
    const newFull = waCountryCode + newLocal;
    setProfile({ ...profile, whatsapp: newFull });
  }

  // ====== Save profile (robust) ======
  async function handleSave(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (saving) return;

    try {
      const orig = originalRef.current || { name: "", whatsapp: "" };
      const payload = {};

      // --- name if changed & non-empty
      const trimmedName = (profile.name || "").trim();
      if (trimmedName && trimmedName !== (orig.name || "")) {
        payload.name = trimmedName;
      }

      // --- whatsapp/phone if local part provided
      const trimmedLocal = (waLocal || "").trim();
      const trimmedCode  = (waCountryCode || "").trim();
      if (trimmedLocal) {
        const full = trimmedCode + trimmedLocal;
        if (full !== (orig.whatsapp || "")) {
          // أرسل كل المسميات المحتملة
          payload.whatsapp     = full;
          payload.phone        = full;
          payload.mobile       = full;
          payload.country_code = trimmedCode;
        }
      }

      // معلومات تعريفية (اختيارية لكنها مفيدة)
      if (profile.id != null)       payload.id = profile.id;
      if ((profile.username || "").trim()) payload.username = profile.username;

      // لو مفيش أي حاجة هتتبعت — الغِ الإرسال
      if (!Object.keys(payload).length) {
        setToast("⚠️ Nothing to update. Edit a field first.");
        setTimeout(() => setToast(""), 2500);
        return;
      }

      setSaving(true);

      // لوج واضح للتشخيص
      console.debug("[update_profile] payload ->", payload);

      const res = await fetch("https://user-hub.com/update_profile.php", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(payload),
      });

      const raw = await res.text();
      let data;
      try { data = JSON.parse(raw); } catch { data = {}; }

      console.debug("[update_profile] status:", res.status, "raw:", raw);

      if (!res.ok || data.success === false) {
        // حاول اظهار رسالة السيرفر لو متاحة (no_fields, invalid, ...)
        const msg = (data.error || data.message || raw || "Update failed");
        throw new Error(msg);
      }

      // نجاح: ثبّت الـoriginals
      if (payload.name) {
        originalRef.current.name = payload.name;
      }
      if (payload.whatsapp || payload.phone || payload.mobile) {
        originalRef.current.whatsapp =
          payload.whatsapp || payload.phone || payload.mobile;
      }

      // ⬅⬅ الجديد الوحيد: اقفل وضع التعديل بعد الحفظ الناجح
      setCanEdit(false);

      setToast("✅ Profile updated.");
    } catch (err) {
      console.error("[update_profile] error:", err);
      setToast("❌ " + (err.message || "Update failed"));
    } finally {
      setSaving(false);
      setTimeout(() => setToast(""), 3000);
    }
  }

  // Change password — wired to update_profile.php (expects old_password, new_password)
  async function handlePasswordSave() {
    try {
      const oldTrim = (oldPwd || "").trim();
      const newTrim = (newPwd || "").trim();

      if (!oldTrim || !newTrim) {
        setToast("⚠️ Please fill old & new password.");
        setTimeout(() => setToast(""), 2500);
        return;
      }
      if (newTrim.length < 8) {
        setToast("⚠️ New password must be at least 8 chars.");
        setTimeout(() => setToast(""), 2500);
        return;
      }

      setSaving(true);

      const res = await fetch("https://user-hub.com/update_profile.php", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          old_password: oldTrim,
          new_password: newTrim,
        }),
      });

      const raw = await res.text();
      let data;
      try { data = JSON.parse(raw); } catch { data = {}; }

      // لوج للتشخيص
      console.debug("[change_password] status:", res.status, "raw:", raw);

      if (!res.ok || data.success === false) {
        const code = (data.error || "").toString();
        let msg = "Update failed";
        if (code === "missing_fields") msg = "Please fill both old & new password.";
        else if (code === "weak_password") msg = "New password is too weak (min 8).";
        else if (code === "invalid_old_password") msg = "Old password is incorrect.";
        else if (code === "user_not_found") msg = "User record not found.";
        else if (code) msg = code;
        else if (data.message) msg = data.message;
        else if (raw) msg = raw;

        throw new Error(msg);
      }

      setToast("✅ Password updated.");
      // نظّف الواجهة
      setShowPwdChange(false);
      setOldPwd("");
      setNewPwd("");
      setShowOld(false);
      setShowNew(false);
      setTimeout(() => setToast(""), 2500);
    } catch (e) {
      console.error("[change_password] error:", e);
      setToast("❌ " + (e.message || "Failed to change password"));
      setTimeout(() => setToast(""), 3000);
    } finally {
      setSaving(false);
    }
  }

  // logout (GET + CAS logout)
  async function handleLogout() {
    try {
      await fetch("https://user-hub.com/logout.php", {
        method: "GET",
        credentials: "include",
        headers: { Accept: "application/json" }
      }).catch(() => {});
    } catch {}
    const service = getService();
    const casLogout = new URL("https://cas.user-hub.com/logout.php");
    casLogout.searchParams.set("service", service);
    casLogout.searchParams.set("brand", brand.key);
    window.location.href = casLogout.toString();
  }

  // sidebar keyboard nav
  function onLabelKeyDown(e, key) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setSelectedSection(key);
    }
  }

  // right side card content switcher
  function renderRightCard() {
    if (selectedSection === "personal") {
      return (
        <div style={{ ...styles.card, ...styles.cardSm, position: "relative" }}>
          {/* edit button */}
          <button
            type="button"
            aria-label="Edit"
            title={canEdit ? "Disable edit" : "Enable edit"}
            aria-pressed={canEdit}
            onClick={toggleEdit}
            style={{
              ...styles.iconBtn,
              ...(canEdit ? styles.iconBtnActive : {})
            }}
          >
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
            </svg>
          </button>

          <div style={styles.cardTitleLeft}>Personal Information</div>
          <form onSubmit={handleSave}>
            <label style={styles.labelLeft}>Full Name</label>
            <input
              style={{ ...styles.inputSm, ...(!canEdit ? styles.inputHold : {}) }}
              value={profile.name || ""}
              disabled={!canEdit}
              onChange={(e) => handleNameChange(e.target.value)}
            />

            <label style={styles.labelLeft}>User Name</label>
            <input
              style={{ ...styles.inputSm, ...styles.inputHold }}
              value={profile.username || ""}
              disabled
              readOnly
            />

            <label style={styles.labelLeft}>Email</label>
            <input
              style={{ ...styles.inputSm, ...styles.inputHold }}
              value={profile.email || ""}
              disabled
              readOnly
            />

            <label style={styles.labelLeft}>Password</label>
            <div style={styles.pwdRow}>
              <input
                style={{ ...styles.inputSm, ...styles.inputHold, flex: "0 0 72%" }}
                value={"••••••••"}
                disabled
                readOnly
              />
              <button
                type="button"
                onClick={() => setShowPwdChange((v) => !v)}
                style={styles.changePwdLink}
              >
                Change password
              </button>
            </div>

            {showPwdChange && (
              <div style={{ marginTop: 8 }}>
                <div style={{ marginBottom: 8 }}>
                  <label style={styles.labelLeft}>Old password</label>
                  <div style={styles.eyeWrap}>
                    <input
                      style={{ ...styles.inputSm, width: "100%" }}
                      type={showOld ? "text" : "password"}
                      value={oldPwd}
                      onChange={(e) => setOldPwd(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => setShowOld((v) => !v)}
                      style={styles.eyeBtn}
                      aria-label={showOld ? "Hide password" : "Show password"}
                    >
                      {/* eye icon */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        {showOld ? (
                          <>
                            <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-10-8-10-8a18.3 18.3 0 0 1 5.06-5.94" />
                            <path d="M1 1l22 22" />
                            <path d="M9.88 9.88A3 3 0 0 0 12 15a3 3 0 0 0 3-3 3 3 0 0 0-.88-2.12" />
                          </>
                        ) : (
                          <>
                            <path d="M1 12s3-8 11-8 11 8 11 8-3 8-11 8-11-8-11-8Z" />
                            <circle cx="12" cy="12" r="3" />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>

                <div>
                  <label style={styles.labelLeft}>New password</label>
                  <div style={styles.eyeWrap}>
                    <input
                      style={{ ...styles.inputSm, width: "100%" }}
                      type={showNew ? "text" : "password"}
                      value={newPwd}
                      onChange={(e) => setNewPwd(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => setShowNew((v) => !v)}
                      style={styles.eyeBtn}
                      aria-label={showNew ? "Hide password" : "Show password"}
                    >
                      {/* eye icon */}
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        {showNew ? (
                          <>
                            <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-10-8-10-8a18.3 18.3 0 0 1 5.06-5.94" />
                            <path d="M1 1l22 22" />
                            <path d="M9.88 9.88A3 3 0 0 0 12 15a3 3 0 0 0 3-3 3 3 0 0 0-.88-2.12" />
                          </>
                        ) : (
                          <>
                            <path d="M1 12s3-8 11-8 11 8 11 8-3 8-11 8-11-8-11-8Z" />
                            <circle cx="12" cy="12" r="3" />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>

                <div style={{ ...styles.row, marginTop: 10 }}>
                  <button
                    type="button"
                    onClick={handlePasswordSave}
                    style={styles.primaryBtn}
                  >
                    Save new password
                  </button>
                  <button
                    type="button"
                    onClick={() => { setShowPwdChange(false); setOldPwd(""); setNewPwd(""); }}
                    style={styles.ghostBtn}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            <label style={styles.labelLeft}>Date of Birth</label>
            <div style={styles.dobRow}>
              <select
                value={dobDay}
                onChange={(e) => setDobDay(e.target.value)}
                style={{ ...styles.selectSm, ...(!canEdit ? styles.selectHold : {}) }}
                disabled={!canEdit}
              >
                <option value="">Day</option>
                {Array.from({ length: 31 }, (_, i) =>
                  String(i + 1).padStart(2, "0")
                ).map((d) => (
                  <option key={d} value={d}>
                    {parseInt(d, 10)}
                  </option>
                ))}
              </select>

              <select
                value={dobMonth}
                onChange={(e) => setDobMonth(e.target.value)}
                style={{ ...styles.selectSm, ...(!canEdit ? styles.selectHold : {}) }}
                disabled={!canEdit}
              >
                <option value="">Month</option>
                {[
                  { v: "01", t: "Jan" },
                  { v: "02", t: "Feb" },
                  { v: "03", t: "Mar" },
                  { v: "04", t: "Apr" },
                  { v: "05", t: "May" },
                  { v: "06", t: "Jun" },
                  { v: "07", t: "Jul" },
                  { v: "08", t: "Aug" },
                  { v: "09", t: "Sep" },
                  { v: "10", t: "Oct" },
                  { v: "11", t: "Nov" },
                  { v: "12", t: "Dec" }
                ].map((m) => (
                  <option key={m.v} value={m.v}>
                    {m.t}
                  </option>
                ))}
              </select>

              <select
                value={dobYear}
                onChange={(e) => setDobYear(e.target.value)}
                style={{ ...styles.selectSm, ...(!canEdit ? styles.selectHold : {}) }}
                disabled={!canEdit}
              >
                <option value="">Year</option>
                {Array.from({ length: 90 }, (_, i) =>
                  String(new Date().getFullYear() - i)
                ).map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>

            <label style={styles.labelLeft}>Mobile (WhatsApp)</label>
            <div style={styles.phoneRow}>
              <select
                style={{ ...styles.countrySelect, ...(!canEdit ? styles.selectHold : {}) }}
                value={waCountryCode}
                disabled={!canEdit}
                onChange={(e) => handleWaCountryChange(e.target.value)}
              >
                {COUNTRIES.map((cObj, idx) => (
                  <option key={idx} value={cObj.code}>
                    {cObj.flag} {cObj.name} ({cObj.code})
                  </option>
                ))}
              </select>

              <input
                style={{ ...styles.inputSm, flex: 1, width: "100%", ...(!canEdit ? styles.inputHold : {}) }}
                value={waLocal}
                disabled={!canEdit}
                onChange={(e) => handleWaLocalChange(e.target.value)}
                placeholder="5XXXXXXX"
              />
            </div>

            <div
              style={{
                color: "#aaa",
                fontSize: 12,
                textAlign: "left",
                marginTop: 4
              }}
            >
              {/* Full: {profile.whatsapp || ""} */}
            </div>

            <div style={styles.row}>
              <button
                type="submit"
                style={{
                  ...styles.primaryBtn,
                  ...((!canEdit || saving) ? styles.btnDisabled : {})
                }}
                disabled={!canEdit || saving}
              >
                {saving ? "Saving..." : "Save changes"}
              </button>
              <button
                type="button"
                style={{
                  ...styles.ghostBtn,
                  ...(!canEdit ? styles.btnDisabled : {})
                }}
                onClick={() => window.location.reload()}
                disabled={!canEdit}
              >
                Reset
              </button>
            </div>
          </form>
        </div>
      );
    }

    if (selectedSection === "history") {
      return (
        <div style={{ ...styles.card, ...styles.cardSm }}>
          <div style={styles.cardTitleLeft}>History</div>
          {historyItems.length === 0 ? (
            <div style={{ color: "#aaa", fontSize: 14 }}>
              No history yet. Start searching or downloading areas to see them
              here.
            </div>
          ) : (
            <ul style={styles.historyList}>
              {historyItems.map((it, idx) => {
                const title =
                  it?.name || it?.query || `Item #${idx + 1}`;
                const subtitle = it?.date || it?.ts || "";
                const meta =
                  it?.type ||
                  (it?.query
                    ? "search"
                    : it?.name
                      ? "download"
                      : "");
                return (
                  <li key={idx} style={styles.historyItem}>
                    <div style={{ fontWeight: 700 }}>{title}</div>
                    <div style={{ color: "#bbb", fontSize: 12 }}>
                      {meta
                        ? meta.toUpperCase()
                        : ""}
                      {subtitle
                        ? " • " +
                          new Date(subtitle).toLocaleString()
                        : ""}
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      );
    }

    if (selectedSection === "Favorite") {
      return (
        <div style={{ ...styles.card, ...styles.cardSm }}>
          <div style={styles.cardTitleLeft}>Favorite</div>
          <div style={{ color: "#aaa" }}>
            Placeholder section. Configure Favorite later.
          </div>
        </div>
      );
    }

    if (selectedSection === "subscription") {
      return (
        <div style={{ ...styles.card, ...styles.cardSm }}>
          <div style={styles.cardTitleLeft}>Orders</div>
          <div style={{ color: "#aaa" }}>
            Placeholder section. Show current plan & upgrade options later.
          </div>
        </div>
      );
    }

    if (selectedSection === "billing") {
      return (
        <div style={{ ...styles.card, ...styles.cardSm }}>
          <div style={styles.cardTitleLeft}>
            {brandKey === "drone" ? "Payment History" : "Payment & Billing"}
          </div>
          <div style={{ color: "#aaa" }}>
            Placeholder section. Add invoices & payment methods later.
          </div>
        </div>
      );
    }

    if (selectedSection === "orders") {
      return (
        <div style={{ ...styles.card, ...styles.cardSm }}>
          <div style={styles.cardTitleLeft}>Orders</div>
          <div style={{ color: "#aaa" }}>
            Placeholder section. Show user orders / purchases for SOBEK.
          </div>
        </div>
      );
    }

    if (selectedSection === "courses") {
      return (
        <div style={{ ...styles.card, ...styles.cardSm }}>
          <div style={styles.cardTitleLeft}>My Courses</div>
          <div style={{ color: "#aaa" }}>
            Placeholder section. List enrolled courses for Drone Pilot.
          </div>
        </div>
      );
    }

    if (selectedSection === "certs") {
      return (
        <div style={{ ...styles.card, ...styles.cardSm }}>
          <div style={styles.cardTitleLeft}>Certificates</div>
          <div style={{ color: "#aaa" }}>
            Placeholder section. Show earned certificates for Drone Pilot.
          </div>
        </div>
      );
    }

    return (
      <div style={{ ...styles.card, ...styles.cardSm }}>
        <div style={styles.cardTitleLeft}>Section</div>
        <div style={{ color: "#aaa" }}>No content yet.</div>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={styles.page}>
        <SobekHeader
          onLogout={handleLogout}
          userName={profile.name || profile.username || "Welcome"}
        />
        <div style={styles.containerOuter}>
          <div style={styles.skelHeader} />
          <div style={styles.grid}>
            <div style={styles.card}>
              <div style={styles.skelLine} />
              <div style={styles.skelLine} />
              <div style={styles.skelLineShort} />
            </div>
            <div style={styles.card}>
              <div style={styles.skelLine} />
              <div style={styles.skelLine} />
              <div style={styles.skelLineShort} />
            </div>
          </div>
        </div>
        {toast ? <div style={styles.toast}>{toast}</div> : null}
        <SobekFooter />
      </div>
    );
  }

  return (
    <div style={styles.page}>
      {/* Header */}
      <SobekHeader
        onLogout={handleLogout}
        userName={profile.name || profile.username || "Welcome"}
      />

      <div style={styles.containerOuter}>
        {/* Grid: left rail + right content */}
        <div ref={gridRef} style={styles.twoColGrid}>
          {/* LEFT SIDE */}
          <div ref={leftColRef} style={styles.leftRail}>
            <div ref={avatarCardRef} style={styles.card}>
              {/* صف أفقي: الصورة + ويلكم نيم */}
              <div style={styles.avatarRow}>
                <div style={styles.avatarLarge(profile.avatar)} />
              </div>

              <div style={{ marginTop: 10, color: "#ccc", fontSize: 13 }}>
                {/* {profile.email || "—"} */}
              </div>
              <div style={{ marginTop: 6, color: "#888", fontSize: 12 }}>
                Member since{" "}
                {profile.created_at
                  ? new Date(profile.created_at).toLocaleDateString()
                  : "—"}
              </div>
            </div>

            {/* dynamic sidebar buttons */}
            {sectionsList.map((sec) => (
              <button
                key={sec.key}
                type="button"
                onClick={() => setSelectedSection(sec.key)}
                onKeyDown={(e) => onLabelKeyDown(e, sec.key)}
                aria-pressed={selectedSection === sec.key}
                style={{
                  ...styles.sideItemBtn,
                  ...(selectedSection === sec.key
                    ? styles.sideItemActive
                    : {})
                }}
              >
                {sec.label}
              </button>
            ))}
          </div>

          {/* RIGHT SIDE */}
          <div style={{ ...styles.rightContent, marginTop: rightOffset + 28 }}>
            {/* الاسم العائم فوق الكارد بدون حاوية */}
            <div style={styles.nameFloating}>
              <span style={styles.nameMuted}>Welcome, </span>
              <span style={styles.nameChip}>
                {profile.name || profile.username || "User"}
              </span>
            </div>

            {renderRightCard()}
          </div>
        </div>
      </div>

      {toast ? <div style={styles.toast}>{toast}</div> : null}

      <SobekFooter />
    </div>
  );
}

/* =========================
   SOBEK Header  — EXACT same style as Register
   ========================= */
function SobekHeader({ onLogout }) {
  const brandKey = detectBrandKey();
  const brand = BRANDS[brandKey] || BRANDS.earthscan;
  const [open, setOpen] = useState(false);

  // إغلاق القائمة عند الضغط خارجها
  useEffect(() => {
    function onDocClick(e) {
      const menu = document.getElementById("user-menu-wrap");
      if (menu && !menu.contains(e.target)) setOpen(false);
    }
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  return (
    <div style={headerStyles.header}>
      <div style={headerStyles.headerInner}>
        {/* logo */}
        <a href={brand.siteUrl} style={headerStyles.logoSection} aria-label={brand.name}>
          <img src={brand.logo} alt={`${brand.name} Logo`} style={headerStyles.logoImage} />
        </a>

        {/* nav */}
        <nav style={headerStyles.navSection}>
          <a href="https://sobekglobal.com/" style={headerStyles.navLink}>Home</a>
          <span style={headerStyles.navSep}>|</span>

          <a href="https://sobekglobal.com/services/" style={headerStyles.navLink}>
            Services <span style={headerStyles.navCaret}>▾</span>
          </a>
          <span style={headerStyles.navSep}>|</span>

          <a href="https://sobekglobal.com/training/" style={headerStyles.navLink}>
            Training <span style={headerStyles.navCaret}>▾</span>
          </a>
          <span style={headerStyles.navSep}>|</span>

          <a href="https://sobekglobal.com/store/" style={headerStyles.navLink}>
            Store <span style={headerStyles.navCaret}>▾</span>
          </a>
          <span style={headerStyles.navSep}>|</span>

          <a href="https://sobekglobal.com/our-company/" style={headerStyles.navLink}>
            Our Company <span style={headerStyles.navCaret}>▾</span>
          </a>
          <span style={headerStyles.navSep}>|</span>

          <a href="https://sobekglobal.com/contact-us/" style={headerStyles.navLink}>Contact Us</a>
        </nav>

        {/* actions */}
        <div id="user-menu-wrap" style={headerStyles.headerActions}>
          {onLogout ? (
            <>
              <button
                type="button"
                aria-haspopup="menu"
                aria-expanded={open ? "true" : "false"}
                onClick={() => setOpen((v) => !v)}
                style={headerStyles.avatarBtn}
                title="Account"
              >
                <span
                  style={{
                    ...headerStyles.avatarImg,
                    backgroundImage: `url('${brand.logo}')`
                  }}
                />
              </button>

              {open && (
                <div role="menu" style={headerStyles.userMenu}>
                  <button role="menuitem" onClick={onLogout} style={headerStyles.menuItem}>
                    Logout
                  </button>
                </div>
              )}
            </>
          ) : (
            <>
              <a href="https://sobekglobal.com/sign-in/" style={headerStyles.signBtn}>Sign In</a>
              <a
                href="https://sobekglobal.com/sign-in-beta/"
                style={{ ...headerStyles.signBtn, marginLeft: 16 }}
              >
                Sign In (BETA)
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* =========================
   SOBEK Footer
   ========================= */
function SobekFooter() {
  return (
    <footer style={footerStyles.wrapper}>
      <div style={footerStyles.inner}>
        <div style={footerStyles.colBrand}>
          <img src="/Asset 2.png" alt="SOBEK" style={footerStyles.brandLogo} />
          <p style={footerStyles.text}>
            SOBEK provides advanced engineering, surveying, training, and geospatial solutions.
            We empower organizations with precise data and reliable services across the region.
          </p>
          <div style={footerStyles.socials}>
            <a href="https://facebook.com" style={footerStyles.socialLink} aria-label="Facebook"></a>
            <a href="https://instagram.com" style={footerStyles.socialLink} aria-label="Instagram"></a>
            <a href="https://x.com" style={footerStyles.socialLink} aria-label="Twitter / X"></a>
          </div>
        </div>

        <div style={footerStyles.col}>
          <h4 style={footerStyles.title}>Quick Links</h4>
          <a href="https://sobekglobal.com/" style={footerStyles.link}>Home</a>
          <a href="https://sobekglobal.com/services/" style={footerStyles.link}>Services</a>
          <a href="https://sobekglobal.com/training/" style={footerStyles.link}>Training</a>
          <a href="https://sobekglobal.com/store/" style={footerStyles.link}>Store</a>
          <a href="https://sobekglobal.com/our-company/" style={footerStyles.link}>Our Company</a>
          <a href="https://sobekglobal.com/contact-us/" style={footerStyles.link}>Contact Us</a>
        </div>

        <div style={footerStyles.col}>
          <h4 style={footerStyles.title}>Get In Touch</h4>
          <div style={footerStyles.line}><span style={footerStyles.icon}>📍</span> Headquarter - New Capital, Egypt.</div>
          <div style={footerStyles.line}><span style={footerStyles.icon}>📍</span> Branch - Riyadh, Saudi Arabia.</div>
          <div style={footerStyles.line}><span style={footerStyles.icon}>📞</span> +20 102 143 5596</div>
          <div style={footerStyles.line}><span style={footerStyles.icon}>📞</span> +966 57 842 8969</div>
          <div style={footerStyles.line}><span style={footerStyles.icon}>🌐</span> <a href="https://sobekglobal.com" style={footerStyles.link}>sobekglobal.com</a></div>
          <div style={footerStyles.line}><span style={footerStyles.icon}>✉️</span> <a href="mailto:Info@sobekglobal.com" style={footerStyles.link}>Info@sobekglobal.com</a></div>
        </div>
      </div>
      <div style={footerStyles.bottom}>© {new Date().getFullYear()} SOBEK. All rights reserved.</div>
    </footer>
  );
}

/* =========================
   Styles
   ========================= */
// ---- Header styles (copied to match Register exactly) ----
const headerStyles = {
  header: {
    backgroundColor: '#0b0b0b',
    borderBottom: '1px solid #0e2b2b',
    position: 'sticky',
    top: 0,
    zIndex: 20,
  },
  headerInner: {
    maxWidth: 1280,
    margin: '0 auto',
    padding: '10px 24px',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    gap: 16,
  },
  logoSection: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  logoImage: {
    height: 64,
    display: 'block',
  },
  navSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 14,
    flexWrap: 'wrap',
  },
  navLink: {
    color: '#ffffff',
    textDecoration: 'none',
    fontSize: 16,
    fontWeight: 700,
  },
  navSep: {
    color: '#00e0d0',
    opacity: 0.9,
    fontWeight: 700,
    margin: '0 2px',
  },
  navCaret: {
    fontSize: 12,
    marginLeft: 4,
    color: '#00e0d0',
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  },
  signBtn: {
    background: '#c79231',
    color: '#000',
    textDecoration: 'none',
    padding: '10px 18px',
    borderRadius: 999,
    fontWeight: 800,
    fontSize: 15,
    display: 'inline-block',
    border: 'none',
    cursor: 'pointer'
  },
  // === NEW: Avatar button + dropdown menu ===
  avatarBtn: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    border: '1px solid #1f1f1f',
    background: '#121212',
    padding: 0,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarImg: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'inline-block',
  },
  userMenu: {
    position: 'absolute',
    top: 44,
    right: 0,
    background: '#111',
    border: '1px solid #2a2a2a',
    borderRadius: 8,
    boxShadow: '0 10px 24px rgba(0,0,0,0.3)',
    minWidth: 140,
    padding: 6,
    zIndex: 30,
  },
  menuItem: {
    width: '100%',
    textAlign: 'left',
    background: 'transparent',
    color: '#fff',
    border: 'none',
    padding: '10px 12px',
    borderRadius: 6,
    cursor: 'pointer',
    fontWeight: 700,
    fontSize: 14,
  },
};

// ---- (Old header style object kept untouched but unused) ----
const stylesSobekHeader = {
  navbarWrapper: {
    backgroundColor: "#0b0b0b",
    color: "#ffffff",
    padding: "10px 20px 0px",
    fontFamily: "Arial, sans-serif",
    position: "sticky",
    top: 0,
    zIndex: 10
  },
  navbarInner: {
    maxWidth: "1280px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  leftGroup: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    gap: "20px",
  },
  logoWrap: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
  },
  logoImg: {
    height: "85px",
    objectFit: "contain",
  },
  welcomeBox: { display: "none" },
  welcomeTop: { color: "#fff", fontSize: "14px", fontWeight: 500 },
  welcomeName: { color: "#C18429", fontSize: "16px", fontWeight: 700, maxWidth: "180px", wordBreak: "break-word" },
  navLinksRow: { display: "flex", flexWrap: "wrap", alignItems: "center", gap: "20px", paddingTop: "30px", fontSize: "18px", fontWeight: 600 },
  navLink: { color: "#1ba99e", textDecoration: "none", display: "flex", alignItems: "center", lineHeight: 1.2 },
  rightGroup: { paddingTop: "30px", display: "flex", flexWrap: "wrap", gap: "15px" },
  ctaBtn: {
    backgroundColor: "#C18429",
    color: "#ffffff",
    borderRadius: "24px",
    padding: "10px 20px",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: 1.2,
    textDecoration: "none",
    border: "none",
    cursor: "pointer",
    minWidth: "140px",
    textAlign: "center",
  },
  bottomBorder: { borderBottom: "2px solid " + "#C18429", marginTop: "10px" },
};

const footerStyles = {
  wrapper: {
    backgroundColor: "#0d0d0d",
    borderTop: "1px solid #333",
    marginTop: 40
  },
  inner: {
    maxWidth: 1280,
    margin: "0 auto",
    padding: "32px 20px",
    display: "grid",
    gridTemplateColumns: "1.2fr 1fr 1fr",
    gap: 24
  },
  colBrand: { display: "grid", gap: 10 },
  brandLogo: { height: 90, objectFit: "contain" },
  text: { color: "#ccc", lineHeight: 1.6, fontSize: 14, textAlign: "justify" },
  socials: { display: "flex", gap: 12, marginTop: 6 },
  socialLink: {
    display: "inline-flex",
    width: 34, height: 34, alignItems: "center", justifyContent: "center",
    borderRadius: "50%", background: "#1a1a1a", color: "#fff", textDecoration: "none",
    border: "1px solid #333", fontSize: 16
    },
  col: { display: "grid", gap: 8, alignContent: "start" },
  title: { color: "#1ba99e", marginBottom: 8, fontSize: 18 },
  link: { color: "#fff", textDecoration: "none", fontSize: 14 },
  line: { color: "#ccc", fontSize: 14, display: "flex", gap: 8, alignItems: "center" },
  icon: { color: "#C18429", width: 18, textAlign: "center" },
  bottom: {
    borderTop: "0px",
    backgroundColor: "#d8b16d",
    color: "#000",
    fontSize: 12,
    padding: "10px 20px",
    textAlign: "center",
    fontWeight: 500
  }
};

const styles = {
  page: {
    backgroundColor: "#111",
    minHeight: "100vh",
    color: "#fff",
    fontFamily: "Arial, sans-serif"
  },

  containerOuter: { width: "80%", maxWidth: 1100, margin: "30px auto 60px" },

  twoColGrid: {
    display: "grid",
    gridTemplateColumns: "260px 1fr",
    gap: 24,
    alignItems: "start"
  },
  leftRail: {
    display: "grid",
    gap: 12
  },
  rightContent: {
    display: "grid",
    gap: 24,
    position: "relative" // ليظهر الاسم فوق الكارد بدون دفعه
  },

  sideItemBtn: {
    background: "#141414",
    border: "1px solid #2a2a2a",
    borderRadius: 8,
    padding: "12px 14px",
    fontWeight: 700,
    fontSize: 16,
    color: "#e6e6e6",
    textAlign: "left",
    cursor: "pointer",
    outline: "none"
  },
  sideItemActive: {
    border: "1px solid #30a9de",
    boxShadow: "0 0 0 2px rgba(48,169,222,0.15)",
    background: "#1a1a1a"
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 24
  },

  card: {
    background: "#1a1a1a",
    border: "1px solid #333",
    borderRadius: 8,
    padding: 20,
    boxShadow: "0 0 20px rgba(0,0,0,0.25)"
  },

  cardSm: { padding: 14, maxWidth: 580 ,marginTop:20},

  cardTitleLeft: {
    fontWeight: "bold",
    marginBottom: 12,
    fontSize: 16,
    textAlign: "left"
  },

  labelLeft: {
    display: "block",
    margin: "10px 0 6px",
    color: "#ccc",
    fontSize: 14,
    fontWeight: 700,
    textAlign: "left"
  },

  inputSm: {
    width: "90%",
    padding: 8,
    borderRadius: 6,
    border: "1px solid #555",
    background: "#fff",
    color: "#000",
    fontSize: 13,
    marginBottom: 12
  },

  // مظهر الـ Hold للحقول المقفولة
  inputHold: {
    background: "#161616",
    color: "#e6e6e6",
    border: "1px dashed #2a2a2a"
  },
  selectHold: {
    background: "#161616",
    color: "#e6e6e6",
    border: "1px dashed #2a2a2a"
  },

  centered: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },

  avatarLarge: (url) => ({
    width: 120,
    height: 120,
    borderRadius: "50%",
    border: "2px solid #333",
    background: url
      ? `url("${url}") center/cover no-repeat`
      : "#222"
  }),

  // الصف الأفقي للصورة + الترحيب
  avatarRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    justifyContent: "center" // ⬅️ التوسيط في منتصف الكارت فقط
  },
  welcomeTextLeft: {
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.2
  },
  welcomeTopLeft: {
    color: "#ddd",
    fontSize: 13
  },
  welcomeNameLeft: {
    color: "#C18429",
    fontWeight: 700,
    fontSize: 16,
    maxWidth: 150,
    wordBreak: "break-word"
  },

  dobRow: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    marginBottom: 12,          // ⬅️ زيادة بسيطة
    width: "90%"              // ⬅️ توحيد عرض صفّ التاريخ
  },
  selectSm: {
    flex: 1,
    padding: 8,
    borderRadius: 6,
    border: "1px solid #555",
    background: "#fff",
    color: "#000",
    minWidth: 90,
    fontSize: 13
  },

  phoneRow: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    flexWrap: "nowrap",
    marginBottom: 12,          // ⬅️ زيادة بسيطة
    width: "90%"
  },
  countrySelect: {
    backgroundColor: "#fff",
    color: "#000",
    border: "1px solid #555",
    borderRadius: 6,
    padding: "8px",
    fontSize: 13,
    minWidth: "150px",
    height: "36px",
    lineHeight: "20px"
  },

  row: { display: "flex", gap: 8, marginTop: 14 },
  primaryBtn: {
    background: "#30a9de",
    color: "#fff",
    border: 0,
    padding: "9px 12px",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: 700,
    fontSize: 13
  },
  ghostBtn: {
    background: "#e6e6e6",
    color: "#000",
    border: 0,
    padding: "9px 12px",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: 700,
    fontSize: 13
  },

  iconBtn: {
    position: "absolute",
    top: 8,
    right: 8,
    background: "#141414",
    border: "1px solid #2a2a2a",
    borderRadius: 6,
    padding: 6,
    cursor: "pointer",
    color: "#ccc"
  },
  iconBtnActive: {
    borderColor: "#30a9de",
    color: "#30a9de",
    boxShadow: "0 0 0 2px rgba(48,169,222,0.15)"
  },

  btnDisabled: {
    opacity: 0.5,
    cursor: "not-allowed"
  },

  // Password row
  pwdRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    width: "90%",            // ⬅️ توحيد عرض صفّ الباسورد
    marginBottom: 12         // ⬅️ مسافة أسفل صف الباسورد
  },
  changePwdLink: {
    background: "transparent",
    color: "#30a9de",
    border: "none",
    cursor: "pointer",
    fontWeight: 700,
    fontSize: 13,
    textDecoration: "underline"
  },
  eyeWrap: {
    position: "relative",
    width: "90%"
  },
  eyeBtn: {
    position: "absolute",
    right: 8,
    top: 6,
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#333",
    padding: 4
  },

  historyList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "grid",
    gap: 12
  },
  historyItem: {
    background: "#161616",
    border: "1px solid #2a2a2a",
    borderRadius: 8,
    padding: 12
  },

  skelHeader: {
    height: 28,
    background: "#1a1a1a",
    border: "1px solid #333",
    borderRadius: 8,
    marginBottom: 24
  },
  skelLine: {
    height: 16,
    background: "#222",
    marginBottom: 10,
    borderRadius: 6
  },
  skelLineShort: {
    height: 16,
    width: "60%",
    background: "#222",
    borderRadius: 6
  },

  toast: {
    position: "fixed",
    right: 16,
    bottom: 16,
    background: "#1a1a1a",
    border: "1px solid #444",
    color: "#fff",
    padding: "10px 14px",
    borderRadius: 8,
    boxShadow: "0 0 20px rgba(0,0,0,0.3)"
  },

  // === الاسم يطفو فوق كارد الإنفو بدون حاوية/بوكس ===
  nameMuted: {
    color: "#aaa",
    fontSize: 14,
    fontWeight: 600,
    marginRight: 4
  },

  nameFloating: {
    position: "absolute",
    top: -18,   // ⬅️ كانت -28: نزول سنة صغيرة
    left: 0,
    marginLeft:10,
    pointerEvents: "none"
  },
  nameChip: {
    display: "inline",
    padding: 0,
    border: "none",
    borderRadius: 0,
    background: "transparent",
    boxShadow: "none",
    color: "#C18429",
    fontSize: 14,
    fontWeight: 800
  }
};
